module.exports = __webpack_public_path__ + "img/pie-chart-2.6d3ae041.svg";